<template>
  <div class="">
    <div class="row justify-content-center py-5 einblenden1">
      <div class="col-lg-10 grauHintergrund">
        <!-- Polsterfolie-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildPolstermaterial/Polsterfolie.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                <h2 class="kachelHeader">Polsterfolie</h2>
                Unsere Polsterfolie bietet zuverlässigen Schutz für empfindliche Produkte
                während Transport und Lagerung. Die Luftpolster wirken stoßdämpfend und
                verhindern Kratzer, Brüche oder andere Transportschäden. Sie ist leicht,
                flexibel und einfach in der Handhabung – ideal zum Einwickeln, Ausfüllen
                oder Auspolstern verschiedenster Waren. Ob für Glas, Elektronik, Keramik
                oder andere sensible Güter: Mit unserer Polsterfolie sorgen Sie für eine
                sichere und professionelle Verpackungslösung.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in Meter:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="vplaenge"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="vpbreite"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Stärke in mm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="vphoehe"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="vpText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText" id="basic-addon1">Anzahl</span>
              <input
                type="number"
                class="form-control anzahlFeld"
                v-model="polsterfolie"
              />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addPf()"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedPf" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>

        <!-- Polsterchips-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildPolstermaterial/Chips.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">Polsterchips</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Unsere Polsterchips sind die ideale Lösung zum sicheren Ausfüllen und
                Polstern von Versandkartons. Sie schützen empfindliche Produkte
                zuverlässig vor Stößen, Erschütterungen und Transportschäden, indem sie
                Hohlräume effektiv ausgleichen. Die Chips sind leicht, formstabil und
                besonders einfach in der Anwendung. Je nach Variante, bestehen sie aus
                recyclingfähigem Kunststoff oder umweltfreundlichen Materialien wie
                Maisstärke – perfekt für nachhaltige Verpackungslösungen mit hoher
                Schutzwirkung.
              </div>
              <div class="col-lg-4">
                <span class="input-group-text" style="width: 100%" id="basic-addon1"
                  >Kurze Beschreibung</span
                >
                <div class="input-group mb-3">
                  <textarea
                    class="form-control"
                    aria-label="With textarea"
                    v-model="pcText"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="pc" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addPc()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedPc" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>

        <!-- PE-Folie-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildPolstermaterial/PE-Folie.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">PE-Folie</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Unsere PE-Folie ist eine vielseitige Verpackungslösung für den Schutz, die
                Bündelung und die Abdeckung unterschiedlichster Produkte. Sie besteht aus
                hochwertigem Polyethylen und zeichnet sich durch ihre Reißfestigkeit,
                Flexibilität und Feuchtigkeitsbeständigkeit aus. Ob als Abdeckfolie,
                Schrumpffolie, Einleger oder zum Umwickeln von Paletten – PE-Folie lässt
                sich individuell einsetzen und sorgt für zuverlässige Sicherheit beim
                Transport und bei der Lagerung. Auf Wunsch auch in verschiedenen Stärken,
                Breiten und Ausführungen erhältlich.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="pelaenge"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="pebreite"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Stärke in my:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="pehoehe"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="peText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="pe" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addPe()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedPe" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>
        <!-- PE-Folie-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildPolstermaterial/Polsterschaum.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">Polsterschaum</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Nachhaltiger Polsterschaum – 100 % recycelt & recycelbar.<br />
                Unser Polsterschaum wird vollständig aus recyceltem Material hergestellt
                und ist selbst zu 100 % recycelbar. Er schützt Ihre Produkte zuverlässig
                beim Versand – und schont dabei die Umwelt. <br />Durch die
                Wiederverwertung von Schaumstoffresten senken wir den CO₂-Fußabdruck
                deutlich im Vergleich zu herkömmlichem Polsterschaum. Ideal für
                Unternehmen, die Wert auf nachhaltige Verpackung und Ressourcenschonung
                legen. <br />Umweltfreundlich. Effizient. Sicher.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="pmlaenge"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="pmbreite"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Höhe in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="pmhoehe"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="pmText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="pm" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addPm()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedPm" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>
        <!-- Rollen-Wellpappe-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildPolstermaterial/RollenWellpappe.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">Rollen-Wellpappe</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Unsere Rollen-Wellpappe ist die flexible und umweltfreundliche Lösung zum
                Verpacken, Polstern und Schützen unterschiedlichster Produkte. Sie passt
                sich ideal an verschiedene Formen und Größen an und eignet sich
                hervorragend zum Umwickeln empfindlicher Oberflächen, zum Auslegen von
                Versandkartons oder als Zwischenlage. Die stoßdämpfende Wirkung der
                Wellenstruktur sorgt für zuverlässigen Schutz bei Lagerung und Transport.
                Hergestellt aus recycelbarem Material, vereint sie Effizienz und
                Nachhaltigkeit in einem Produkt.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in Meter:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="rwlaenge"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="rwbreite"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Stärke in mm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="rwhoehe"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="rwText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="rw" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addRw()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedRw" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>
        <!-- Packpapier-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildPolstermaterial/Packpapier.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">Packpapier</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Unser Packpapier mit einer Breite von 100cm und einer Lauflänge von 100
                Metern ist die ideale Lösung zum Einwickeln, Auspolstern und Schützen
                verschiedenster Produkte. Es eignet sich hervorragend für den
                professionellen Versand, den sicheren Warentransport sowie als
                umweltfreundliches Füllmaterial. Das stabile, recyclingfähige Papier lässt
                sich leicht verarbeiten, ist vielseitig einsetzbar und schützt zuverlässig
                vor Staub, Kratzern und leichten Stößen. Eine nachhaltige und praktische
                Verpackungslösung für Handel, Lager und Versand.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in Meter:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="pplaenge"
                      disabled
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="ppbreite"
                      disabled
                    />
                  </div>

                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="ppText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="pp" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addPp()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedPp" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>

        <!-- Zuschnitte und Gefache-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildPolstermaterial/Zuschnitte.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">Zuschnitte und Gefache</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Zuschnitte und Gefache aus Wellpappe bieten optimalen Schutz beim Versand.<br/>
                Zuschnitte dienen als Einlagen oder Trennwände, während Gefache Produkte
                sicher voneinander trennen und fixieren. <br/>Ideal für empfindliche oder
                mehrere Artikel in einem Karton. Unsere Lösungen sind individuell
                anpassbar, platzsparend und zu 100 % recycelbar <br/>– für sicheren und
                nachhaltigen Versand.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  
                  

                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="zuText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="zu" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addZu()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedZu" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { anfragenStore } from "@/stores/AnfrageStore";
export default {
  name: "balkenMitBildPaletten",
  data() {
    return {
      vplaenge: 0,
      vpbreite: 0,
      vphoehe: 0,
      vpText: "",
      polsterfolie: 0,
      pc: 0,
      pcText: "",
      pe: 0,
      pelaenge: 0,
      pebreite: 0,
      pehoehe: 0,
      peText: "",
      rw: 0,
      rwlaenge: 0,
      rwbreite: 0,
      rwhoehe: 0,
      rwText: "",
      pplaenge: 100,
      ppbreite: 100,
      ppText: "",
      pp: 0,
      pmlaenge: 0,
      pmbreite: 0,
      pmhoehe: 0,
      pmText: "",
      pm: 0,
      zuText: "",
      zu: 0,

      addedPf: false,
      addedPc: false,
      addedPe: false,
      addedRw: false,
      addedPp: false,
      addedPm: false,
      addedZu: false,
    };
  },

  methods: {
    addPf() {
      let item = {
        name: "Polsterfolie",
        anzahl: this.polsterfolie,
        beschreibung: this.vpText,
        masse: {
          laenge: this.vplaenge,
          breite: this.vpbreite,
          staerkemm: this.vphoehe,
        },
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedPf = true;
      setTimeout(() => {
        this.addedPf = false;
        this.polsterfolie = 0;
        this.vplaenge = 0;
        this.vpbreite = 0;
        this.vphoehe = 0;
        this.vpText = "";
      }, 5000);
    },

    addPc() {
      let item = {
        name: "Polsterchips",
        anzahl: this.pc,
        beschreibung: this.pcText,
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedPc = true;
      setTimeout(() => {
        this.addedPc = false;
        this.pc = 0;
        this.pcText = "";
      }, 5000);
    },
    addPe() {
      let item = {
        name: "PEFolie",
        anzahl: this.pe,
        beschreibung: this.peText,
        masse: {
          laenge: this.pelaenge,
          breite: this.pebreite,
          staerkemy: this.pehoehe,
        },
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedPe = true;
      setTimeout(() => {
        this.addedPe = false;
        this.pe = 0;
        this.pelaenge = 0;
        this.pebreite = 0;
        this.pehoehe = 0;
        this.peText = "";
      }, 5000);
    },
    addRw() {
      let item = {
        name: "RollenWellpappe",
        anzahl: this.rw,
        beschreibung: this.rwText,
        masse: {
          laenge: this.rwlaenge,
          breite: this.rwbreite,
          staerkemm: this.rwhoehe,
        },
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedPf = true;
      setTimeout(() => {
        this.addedPf = false;
        this.rw = 0;
        this.rwlaenge = 0;
        this.rwbreite = 0;
        this.rwhoehe = 0;
        this.rwText = "";
      }, 5000);
    },
    addPp() {
      let item = {
        name: "Packpapier",
        anzahl: this.pp,
        beschreibung: this.ppText,
        masse: {
          laenge: this.pplaenge,
          breite: this.ppbreite,
        },
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedPf = true;
      setTimeout(() => {
        this.addedPf = false;
        this.pp = 0;
        this.pplaenge = 100;
        this.ppbreite = 100;
        this.ppText = "";
      }, 5000);
    },
    addPm() {
      let item = {
        name: "Polsterschaum",
        anzahl: this.pm,
        beschreibung: this.pmText,
        masse: {
          laenge: this.pmlaenge,
          breite: this.pmbreite,
          hoehe: this.pmhoehe,
        },
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedPm = true;
      setTimeout(() => {
        this.addedPm = false;
        this.pm = 0;
        this.pmlaenge = 0;
        this.pmbreite = 0;
        this.pmhoehe = 0;
        this.pmText = "";
      }, 5000);
    },
    addZu() {
      let item = {
        name: "Zuschnitte",
        anzahl: this.zu,
        beschreibung: this.zuText,
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedZu = true;
      setTimeout(() => {
        this.addedZu = false;
        this.zu = 0;
        this.zuText = "";
      }, 5000);
    },
  },
};
</script>
